import React from 'react';

const TermsAndConditions = () => (
  <div style={{ width: '100%', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <iframe
      title="Terms & Conditions"
      src="/Terms%26Conditions.pdf"
      style={{ width: '100%', height: '100vh', border: 'none' }}>
      <p>
        Your browser does not support PDFs. <a href="/Terms%26Conditions.pdf">Download the PDF</a>.
      </p>
    </iframe>
  </div>
);

export default TermsAndConditions;
